import { useMemo } from "react";

import {
  deriveSubmissionStatus,
  type ParticipantSubmissionStatus,
} from "@/lib/opportunity-utils";
import { api } from "@/lib/trpc/react";

export function useParticipationStatuses({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const { data, isLoading } =
    api.opportunityListing.getMyParticipationStatuses.useQuery(undefined, {
      enabled,
    });

  const statusMap = useMemo(() => {
    const map = new Map<string, ParticipantSubmissionStatus>();
    if (!data) {
      return map;
    }
    for (const row of data) {
      map.set(
        row.studyId,
        deriveSubmissionStatus(row.interviewStatus, row.paymentStatus),
      );
    }
    return map;
  }, [data]);

  return { statusMap, isLoading };
}
